<template>
    <div>
        <div class="flex_b_c">
            <div class="title">列表字段管理</div>
            <div class="flex_r_c">
                <el-input v-model.trim="listFieldSearchForm.keyword" maxlength="50" size="small"
                          placeholder="请输入字段名称、别名" clearable class="m_r1"></el-input>
                <el-button type="primary" @click="refreshListFieldList(1)" size="small" icon="el-icon-search">查询
                </el-button>
            </div>
        </div>
        <el-table
                :data="allData.tableListPaging"
                size="small" max-height="300"
                class="table" border>
            <el-table-column prop="basicName" label="字段名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metadataBasicAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="basicRename" label="别名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="basicRequired" label="是否必填" show-overflow-tooltip>
                <template slot-scope="{row}">
                    {{$dictUtils.getDictLabel("public_state", row.basicRequired ,'')}}
                </template>
            </el-table-column>
            <el-table-column prop="basicForEdit" label="组件权限">
                <el-table-column prop="basicForShow" label="可查看">
                    <template slot-scope="{row}">
                        <div :class="[row.basicForShow == '0' ? 'el-icon-success':'el-icon-error']"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="basicForEdit" label="可修改">
                    <template slot-scope="{row}">
                        <div :class="[row.basicForEdit == '0' ? 'el-icon-success':'el-icon-error']"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="basicForAdd" label="可新增">
                    <template slot-scope="{row}">
                        <div :class="[row.basicForAdd == '0' ? 'el-icon-success':'el-icon-error']"></div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="disabled" label="列表显示">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1" :disabled="method == 'view'"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="basicSort" label="列表排序">
                <template slot-scope="scope">
                    <div v-if="method == 'view'">{{scope.row.basicSort}}</div>
                    <el-input-number v-model="scope.row.basicSort" size="mini" :min="1" :max="9999"
                                     placeholder="1-9999" v-else></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="listFieldTotal" :page.sync="listFieldSearchForm.current"
                    :limit.sync="listFieldSearchForm.size" @pagination="refreshListFieldList"/>
        <div class="flex_b_c">
            <div class="title">查询字段管理</div>
            <div class="flex_r_c">
                <el-input v-model.trim="searchFieldSearchForm.keyword" maxlength="50" size="small"
                          placeholder="请输入字段名称、别名" clearable class="m_r1"></el-input>
                <el-button type="primary" @click="refreshSearchFieldList(1)" size="small" icon="el-icon-search">查询
                </el-button>
            </div>
        </div>
        <el-table
                :data="allData.whereListPaging"
                size="small" max-height="300"
                class="table" border>
            <el-table-column prop="basicName" label="字段名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metadataBasicAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="basicRename" label="别名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="basicSort" label="排序" show-overflow-tooltip></el-table-column>
            <el-table-column prop="basicRequired" label="是否必填" show-overflow-tooltip>
                <template slot-scope="{row}">
                    {{$dictUtils.getDictLabel("public_state", row.basicRequired ,'')}}
                </template>
            </el-table-column>
            <el-table-column prop="basicForEdit" label="组件权限">
                <el-table-column prop="basicForShow" label="可查看">
                    <template slot-scope="{row}">
                        <div :class="[row.basicForShow == '0' ? 'el-icon-success':'el-icon-error']"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="basicForEdit" label="可修改">
                    <template slot-scope="{row}">
                        <div :class="[row.basicForEdit == '0' ? 'el-icon-success':'el-icon-error']"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="basicForAdd" label="可新增">
                    <template slot-scope="{row}">
                        <div :class="[row.basicForAdd == '0' ? 'el-icon-success':'el-icon-error']"></div>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="disabled" label="查询条件">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1" :disabled="method == 'view'"></el-switch>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="searchFieldTotal" :page.sync="searchFieldSearchForm.current"
                    :limit.sync="searchFieldSearchForm.size" @pagination="refreshSearchFieldList"/>
        <div class="flex_b_c">
            <div class="title">页面功能选择</div>
            <div class="flex_r_c">
                <el-input v-model.trim="pageFunctionSearchForm.keyword" maxlength="50" size="small"
                          placeholder="请输入功能名称" clearable class="m_r1"></el-input>
                <el-button type="primary" @click="refreshPageFunctionList(1)" size="small" icon="el-icon-search">
                    查询
                </el-button>
            </div>
        </div>
        <el-table
                :data="allData.pageFonctionsListPaging"
                size="small" max-height="300"
                class="table" border>
            <el-table-column prop="detailName" label="功能名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="detailIcon" label="图标">
                <template slot-scope="scope">
                    <div :class="[scope.row.detailIcon]"></div>
                </template>
            </el-table-column>
            <el-table-column prop="metadataTableConfigPageWhereList" label="隐藏条件" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{getPageWhere(row)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="disabled" label="启用状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1"
                               :disabled="method == 'view'"></el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="240" label="操作">
                <template slot-scope="{row}">
                    <el-button type="text" size="small" @click="viewEdit(row, 'view', 'page')">查看</el-button>
                    <el-button type="text" size="small" @click="viewEdit(row, 'edit', 'page')" v-if="method != 'view'">修改</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="pageFunctionTotal" :page.sync="pageFunctionSearchForm.current"
                    :limit.sync="pageFunctionSearchForm.size" @pagination="refreshPageFunctionList"/>
        <div class="flex_b_c">
            <div class="title">列表功能选择</div>
            <div class="flex_r_c">
                <el-input v-model.trim="listFunctionSearchForm.keyword" maxlength="50" size="small"
                          placeholder="请输入功能名称" clearable class="m_r1"></el-input>
                <el-button type="primary" @click="refreshListFunctionList(1)" size="small" icon="el-icon-search">
                    查询
                </el-button>
            </div>
        </div>
        <el-table
                :data="allData.tableFonctionsListPaging"
                size="small" max-height="300"
                class="table" border>
            <el-table-column prop="detailName" label="功能名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="detailIcon" label="图标">
                <template slot-scope="scope">
                    <div :class="[scope.row.detailIcon]"></div>
                </template>
            </el-table-column>
            <el-table-column prop="metadataTableConfigPageWhereList" label="隐藏条件" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{getPageWhere(row)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="disabled" label="启用状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1"
                               :disabled="method == 'view'"></el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="240" label="操作">
                <template slot-scope="{row}">
                    <el-button type="text" size="small" @click="viewEdit(row, 'view', 'list')">查看</el-button>
                    <el-button type="text" size="small" @click="viewEdit(row, 'edit', 'list')" v-if="method != 'view'">修改</el-button>
                </template>
            </el-table-column>

        </el-table>
        <pagination :total="listFunctionTotal" :page.sync="listFunctionSearchForm.current"
                    :limit.sync="listFunctionSearchForm.size" @pagination="refreshListFunctionList"/>
        <div class="flex_b_c">
            <div class="title">表单功能选择</div>
            <div class="flex_r_c">
                <el-input v-model.trim="fromFonctionsSearchForm.keyword" maxlength="50" size="small"
                          placeholder="请输入功能名称" clearable class="m_r1"></el-input>
                <el-button type="primary" @click="refreshFromFonctionsList(1)" size="small" icon="el-icon-search">
                    查询
                </el-button>
            </div>
        </div>
        <el-table
                :data="allData.fromFonctionsListPaging"
                size="small" max-height="300"
                class="table" border>
            <el-table-column prop="detailName" label="功能名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="detailIcon" label="图标">
                <template slot-scope="scope">
                    <div :class="[scope.row.detailIcon]"></div>
                </template>
            </el-table-column>
            <el-table-column prop="metadataTableConfigPageWhereList" label="隐藏条件" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{getPageWhere(row)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="disabled" label="启用状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.disabled" active-value="0" inactive-value="1"
                               :disabled="method == 'view'"></el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="240" label="操作">
                <template slot-scope="{row}">
                    <el-button type="text" size="small" @click="viewEdit(row, 'view', 'from')">查看</el-button>
                    <el-button type="text" size="small" @click="viewEdit(row, 'edit', 'from')" v-if="method != 'view'">修改</el-button>
                </template>
            </el-table-column>

        </el-table>
        <pagination :total="fromFonctionsTotal" :page.sync="fromFonctionsSearchForm.current"
                    :limit.sync="fromFonctionsSearchForm.size" @pagination="refreshFromFonctionsList"/>
        <!--<div class="flex_b_c">
            <div class="title">整列特定样式设置</div>
            <div class="flex_r_c">
                <el-input v-model.trim="styleSearchForm.keyword" maxlength="50" size="small"
                          placeholder="请输入字段名称、别名" clearable class="m_r1"></el-input>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
            </div>
        </div>
        <el-table
                :data="styleList"
                size="small" max-height="300"
                class="table" border>
            <el-table-column prop="basicRename" label="样式名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metadataBasicAssemblyName" label="样式" show-overflow-tooltip></el-table-column>
            <el-table-column prop="metadataBasicAssemblyName" label="条件" show-overflow-tooltip></el-table-column>
            <el-table-column prop="basicRequired" label="启用状态">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.basicEnable" active-value="0" inactive-value="1"></el-switch>
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="240" label="操作">
                <template slot-scope="{row}">
                    <el-button type="text" size="small" @click="viewEdit(row, 'view', 'style')">查看</el-button>
                    <el-button type="text" size="small" @click="viewEdit(row, 'edit', 'style')">修改</el-button>
                    <el-button type="text" size="small" @click="delData(row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="styleTotal" :page.sync="styleSearchForm.current" :limit.sync="styleSearchForm.size"
                    @pagination="refreshList"/>-->
        <ConditionForm ref="conditionForm" @getInfo="getInfo"></ConditionForm>

    </div>
</template>

<script>
    import ConditionForm from './conditionForm'

    export default {
        name: "ListData",
        components: {ConditionForm},
        props: {
            // 模板列表数据
            templateData: {
                type: Object,
            },
            // 查看、修改
            method: {
                type: String
            },
            // 模板数据
            basicDataIdList: {
                type: Array,
            },
            // 当前模板id
            basicDataId: {
                type: String
            },
        },
        data() {
            return {
                // 列表字段管理
                listFieldSearchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                listFieldList: [],
                listFieldListAll: [],
                listFieldTotal: 0,
                // 查询字段管理
                searchFieldSearchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                searchFieldList: [],
                searchFieldListAll: [],
                searchFieldTotal: 0,
                // 页面功能选择
                pageFunctionSearchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                pageFunctionList: [],
                pageFunctionListAll: [],
                pageFunctionTotal: 0,
                // 列表功能选择
                listFunctionSearchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                listFunctionList: [],
                listFunctionListAll: [],
                listFunctionTotal: 0,
                // 表单功能选择
                fromFonctionsSearchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                fromFonctionsList: [],
                fromFonctionsListAll: [],
                fromFonctionsTotal: 0,
                // 整列特定样式设置
                styleSearchForm: {
                    keyword: '',
                    current: 1,
                    size: 20,
                },
                styleList: [],
                styleTotal: 0,
                allData: [],
                config: [],
            }
        },
        mounted() {
            this.allData = this.templateData
            this.config = this.basicDataIdList.filter(v => v.basicDataId == this.basicDataId)[0].children
            this.refreshListFieldList(1)
            this.refreshSearchFieldList(1)
            this.refreshPageFunctionList(1)
            this.refreshListFunctionList(1)
            this.refreshFromFonctionsList(1)
        },
        methods: {
            // 刷新列表字段管理
            refreshListFieldList(type) {
                let {current, size, keyword} = this.listFieldSearchForm
                if (type == 1) {
                    current = 1
                }
                this.templateData.tableList.map(item => {
                    this.$set(item, 'showType', '0')
                })
                let list = this.templateData.tableList.filter(item => item.basicRename && item.basicRename.includes(keyword))
                this.$set(this.allData, 'tableListPaging', list.slice(
                    (current - 1) * size,
                    current * size
                ))
                this.listFieldTotal = list.length
            },
            // 刷新查询字段管理
            refreshSearchFieldList(type) {
                let {current, size, keyword} = this.searchFieldSearchForm
                if (type == 1) {
                    current = 1
                }
                this.templateData.whereList.map(item => {
                    this.$set(item, 'showType', '1')
                })
                let list = this.templateData.whereList.filter(item => item.basicRename && item.basicRename.includes(keyword))
                this.$set(this.allData, 'whereListPaging', list.slice(
                    (current - 1) * size,
                    current * size
                ))
                this.searchFieldTotal = list.length
            },
            // 刷新页面功能选择
            refreshPageFunctionList(type) {
                let {current, size, keyword} = this.pageFunctionSearchForm
                if (type == 1) {
                    current = 1
                }
                let list = this.templateData.pageFonctionsList.filter(item => item.detailName && item.detailName.includes(keyword))
                this.$set(this.allData, 'pageFonctionsListPaging', list.slice(
                    (current - 1) * size,
                    current * size
                ))
                this.pageFunctionTotal = list.length
            },
            // 刷新列表功能选择
            refreshListFunctionList(type) {
                let {current, size, keyword} = this.listFunctionSearchForm
                if (type == 1) {
                    current = 1
                }
                let list = this.templateData.tableFonctionsList.filter(item => item.detailName && item.detailName.includes(keyword))
                this.$set(this.allData, 'tableFonctionsListPaging', list.slice(
                    (current - 1) * size,
                    current * size
                ))
                this.listFunctionTotal = list.length
            },
            // 刷新表单功能选择
            refreshFromFonctionsList(type) {
                let {current, size, keyword} = this.fromFonctionsSearchForm
                if (type == 1) {
                    current = 1
                }
                let list = this.templateData.fromFonctionsList.filter(item => item.detailName && item.detailName.includes(keyword))
                this.$set(this.allData, 'fromFonctionsListPaging', list.slice(
                    (current - 1) * size,
                    current * size
                ))
                this.fromFonctionsTotal = list.length
            },
            // 查看、修改
            viewEdit(data, method, pageType) {
                this.$refs.conditionForm.init(data, method, pageType, this.config)
            },
            // 获取修改的信息
            getInfo(data) {
                let item = {}
                if(data.pageType == 'page') {
                    item = this.templateData.pageFonctionsList.filter(v => v.metadataFonctionsModelDetailId == data.form.metadataFonctionsModelDetailId)[0]
                } else if(data.pageType == 'list') {
                    item = this.templateData.tableFonctionsList.filter(v => v.metadataFonctionsModelDetailId == data.form.metadataFonctionsModelDetailId)[0]
                } else if(data.pageType == 'from') {
                    item = this.templateData.fromFonctionsList.filter(v => v.metadataFonctionsModelDetailId == data.form.metadataFonctionsModelDetailId)[0]
                }
                this.$set(item, 'metadataTableConfigPageWhereList', data.form.metadataTableConfigPageWhereList)
                this.$set(item, 'disabled', data.form.disabled)
            },
            // 隐藏条件
            getPageWhere(row) {
                if(!row.metadataTableConfigPageWhereList) {
                    return
                }
                let val = ''
                row.metadataTableConfigPageWhereList.map((item, index) => {
                    let basicRangeList = [], basicRangeListArr = this.config.filter(c => c.basicCode == item.basicCode)
                    if(basicRangeListArr && basicRangeListArr.length) {
                        basicRangeList = basicRangeListArr[0].basicRangeList
                    }
                    if(index > 0) {
                        val += this.$dictUtils.getDictLabel("conditionApproach", item.conditionApproach,'')
                    }
                    val += item.basicRename + this.$dictUtils.getDictLabel("condition", item.condition,'')
                    item.whereDetail.map((v, i) => {
                        if(item.basicAssemblyId == 4 || item.basicAssemblyId == 5 || item.basicAssemblyId == 6 || item.basicAssemblyId == 7 || item.basicAssemblyId == 10) {
                            let basicRangeArr = basicRangeList.filter(r => r.metadataRangeId == v)
                            if(basicRangeArr && basicRangeArr.length) {
                                let basicRange = basicRangeArr[0].basicRange
                                val  += basicRange
                            }
                        } else {
                            val  += this.listDataFormat(item, v)
                        }
                        if(i < item.whereDetail.length-1) {
                            val  += '、'
                        }
                    })
                    if(item.promptMessage) {
                        val  += '，' + item.promptMessage
                    }
                    if(index < row.metadataTableConfigPageWhereList.length-1) {
                        val += '；'
                    }
                })
                return val

            },
            // 整列特定样式设置-删除
            delData() {

            },
        }
    }
</script>

<style scoped>
    .title {
        font-size: 14px;
        color: #000;
        margin: 10px 0 20px;
        font-weight: bold;
    }

    .el-icon-success, .el-icon-error {
        font-size: 18px;
        padding-top: 6px;
        color: green;
    }

    .el-icon-error {
        color: red;
    }
</style>
